// @flow
import { useEffect, useRef } from 'react';

import { useLocation, useNavigate, Outlet } from 'react-router-dom';

/**
 * QueryPersister intercepts navigations and preserves the feature flags (ff-*).
 */
export function QueryPersister(): React.MixedElement {
  const location = useLocation();
  const navigate = useNavigate();
  // Store previous query string for comparison
  const prevSearchRef = useRef(location.search);

  useEffect(() => {
    const currentParams = new URLSearchParams(location.search);
    const prevParams = new URLSearchParams(prevSearchRef.current);
    let shouldUpdate = false;

    // Iterate over previous params to find feature flags
    prevParams.forEach((value, key) => {
      // Condition: Persist keys starting with 'ff-' if missing in current params
      if (key.startsWith('ff-') && !currentParams.has(key)) {
        currentParams.set(key, value);
        shouldUpdate = true;
      }
    });

    // Replace URL if parameters were injected
    if (shouldUpdate) {
      navigate(
        {
          pathname: location.pathname,
          search: currentParams.toString(),
          hash: location.hash,
        },
        { replace: true, state: location.state },
      );
    }

    // Update reference for next navigation
    prevSearchRef.current = location.search;
  }, [location, navigate]);

  return <Outlet />;
}
